import { useQuery } from '@tanstack/react-query';
import { supabase } from '../lib/supabase';

export interface ReportingSummary {
    generated_at: string;
    builders: { name: string; count: number }[];
    stages: { name: string; sequence_order: number; count: number }[];
    pours_by_week: { week_start: string; count: number }[];
    crew_load: { name: string; count: number }[];
    tiles: {
        active_jobs: number;
        needs_review: number;
        flatwork_active: number;
        scheduled_total: number;
    };
}

export function useReportingSummary() {
    return useQuery({
        queryKey: ['reportingSummary'],
        queryFn: async (): Promise<ReportingSummary> => {
            const { data, error } = await supabase.rpc('reporting_summary');
            if (error) throw error;
            return data as ReportingSummary;
        },
        staleTime: 1000 * 60 * 5,
        refetchInterval: 1000 * 60 * 5,
    });
}
